import { render } from "./EntitiesNotRegistered.vue?vue&type=template&id=388ce9a8&scoped=true"
import script from "./EntitiesNotRegistered.vue?vue&type=script&lang=js"
export * from "./EntitiesNotRegistered.vue?vue&type=script&lang=js"

import "./EntitiesNotRegistered.vue?vue&type=style&index=0&id=388ce9a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388ce9a8"]])

export default __exports__